import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentMoney = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor, ...props }: { fillColor?: string } & SvgProps, ref) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M10.5 8a3 3 0 100 6 3 3 0 000-6zM9 11a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z'
        fill={fillColor}
      />
      <Path
        d='M2 7.25A2.25 2.25 0 014.25 5h12.5A2.25 2.25 0 0119 7.25v7.5A2.25 2.25 0 0116.75 17H4.25A2.25 2.25 0 012 14.75v-7.5zm2.25-.75a.75.75 0 00-.75.75V8h.75A.75.75 0 005 7.25V6.5h-.75zm-.75 6h.75a2.25 2.25 0 012.25 2.25v.75h8v-.75a2.25 2.25 0 012.25-2.25h.75v-3h-.75a2.25 2.25 0 01-2.25-2.25V6.5h-8v.75A2.25 2.25 0 014.25 9.5H3.5v3zm14-4.5v-.75a.75.75 0 00-.75-.75H16v.75c0 .414.336.75.75.75h.75zm0 6h-.75a.75.75 0 00-.75.75v.75h.75a.75.75 0 00.75-.75V14zm-14 .75c0 .414.336.75.75.75H5v-.75a.75.75 0 00-.75-.75H3.5v.75z'
        fill={fillColor}
      />
      <Path
        d='M4.401 18.5A2.999 2.999 0 007 20h10.25A4.75 4.75 0 0022 15.25V10a3 3 0 00-1.5-2.599v7.849a3.25 3.25 0 01-3.25 3.25H4.401z'
        fill={fillColor}
      />
    </Svg>
  )
)

export default FluentMoney
